module.exports = __webpack_public_path__ + "img/kaopu02.304c4ed8.jpg";